import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { useRESTDataCache } from 'dataProvider';
import { PROPERTIES_JSON } from 'core/constants';

export const Properties = createContext();

export const PropertiesProvider = ({ children }) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);

  if (!params) {
    return null;
  }

  return (
    <Properties.Provider value={{ params }}>{children}</Properties.Provider>
  );
};

PropertiesProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useContextProperties = () => useContext(Properties);
